const json = {
    GE: {
        MY_BOOK: 'ჩემი წიგნი',
        LOG_OUT: 'გამოსვლა',
        GENERATE: 'დააგენერირე',
        PERSONAL_GUIDEBOOK: 'პერსონალიზებული გზამკვლევი',
        BEEN_IN_GEORGIA: 'ყოფილხარ საქართველოში?',
        ARE_YOU_CONTRIBUTOR_ONE: 'გაიგე, ხარ თუ არა',
        ARE_YOU_CONTRIBUTOR_TWO: 'ავტორი',
        NOT_FOUND: 'გაზიარებული ემოციები არ მოიძებნა',
        MORE: 'ნახე მეტი'
    },
    EN: {
        MY_BOOK: 'My book',
        LOG_OUT: 'Log out',
        GENERATE: 'Generate',
        PERSONAL_GUIDEBOOK: 'your personal guidebook',
        BEEN_IN_GEORGIA: 'Have you ever been in Georgia?',
        ARE_YOU_CONTRIBUTOR_ONE: 'Find out if you are',
        ARE_YOU_CONTRIBUTOR_TWO: 'a contributor',
        NOT_FOUND: 'Shared Moments not found',
        MORE: 'View more'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/sharedmoments.texts.js